import React, {useState, useEffect} from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from "react-redux";
import { authLogin, setAuthAlert } from '../../redux/reducers/appReducer'

import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, TextField, Button,  } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import InputMask from "react-input-mask";
import validate from 'validate.js';

const schema = {
  login: {
    presence: true,
    format: {
      pattern: /^\+7\(\d\d\d\)\d\d\d-\d\d-\d\d$/,
      message: '^Введите номер телефона в федеральном формате' 
    },
   
    length: {
      maximum: 64
    }
  },
  password: {
    
    presence: { allowEmpty: false, message: '^Введите пароль' },
    length: {
      maximum: 128
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100vh',
  },
  grid: {
    height: '100%'
  },
  rightContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    },
  },
  tr: {
    position:'fixed',
    right: '0',
    bottom:'0',
    width: '0', 
    height: '0',
  	borderBottom: '100vh solid '+theme.palette.primary.main ,
	  borderLeft: '100vh solid transparent',
    },
  logo: {
    position:'fixed',
    width: '30vh', 
    height: '30vh',
    right: '0',
    bottom:'0',
    color: 'black',
    backgroundImage: 'url(images/logo_vertikal.svg)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    marginRight: '5vh',
    marginBottom: '5vh'
  },
  logo2: {
    textAlign: 'center'
  },
  trLeft: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    },
    position:'fixed',
    width: '0px', 
    height: '0px',
    borderTop: '25vh solid '+theme.palette.primary.main ,
    borderRight: '25vh solid transparent',
      },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 200,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 500,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  size: {
    fontSize:'16px'
  }
}));

const SignIn = props => {
  const { history } = props;
  const classes = useStyles();

  const { authAlert } = useSelector(state => state.appReducer); 
  const dispatch = useDispatch();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSignIn = event => {
    event.preventDefault();
    //console.log(props);

    

    dispatch(authLogin(formState.values.login.replace(/[^\d]/g, ''), formState.values.password, history));
    setFormState({
      isValid: false,
      values: {},
      touched: {},
      errors: {}
    });
  };

  const hasError = field => formState.touched[field] && formState.errors[field] ? true : false;
  const disable = Boolean(authAlert);

  return (
    <div className={classes.root}>
      <Grid className={classes.grid} container>
      <div className={classes.trLeft}></div> 
      <Grid className={classes.content} item lg={6} xs={12}>
        <div className={classes.contentBody}>
     
          <form className={classes.form}//onSubmit={handleSignIn}
          >
               <div className={classes.logo2}>
                 <img width={170} src="images/logo_vertikal_y.svg" />
                </div>

                <Typography className={classes.title} variant="h2">
                  Авторизация
                </Typography>

                <InputMask  
                  mask="+7(999)999-99-99"
                  maskChar="_"
                  value={formState.values.login || ''} 
                  onChange={handleChange} 
                  error={hasError('login')}
                  helperText={ hasError('login') ? formState.errors.login[0] : null }
                  disabled={disable}
                  >

                  <TextField
                    className={classes.textField}
                    fullWidth
                    label="Номер телефона"
                    type="text"
                    variant="outlined"
                    name="login"
                    // InputProps={{
                    //   classes: {
                    //     input: classes.size,
                    //   },
                    // }}
                    />
                  </InputMask> 

                
                <TextField
                  className={classes.textField}
                  fullWidth
                  label="Пароль"
                  type="password"
                  variant="outlined"
                  name="password"
                  error={hasError('password')}
                  value={formState.values.password || ''}
                  helperText={ hasError('password') ? formState.errors.password[0] : null }
                  onChange={handleChange}
                  disabled={disable}
                  // InputProps={{
                  //   classes: {
                  //     input: classes.size,
                  //   },
                  // }}
                />
                
                
               
              <Button
                className={classes.signInButton}
                color="primary"
                disabled={!formState.isValid||disable}
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={handleSignIn}
              >
                Войти
              </Button>
              {Boolean(authAlert)
                ?<Alert severity="error" onClose={() => {dispatch(setAuthAlert(undefined))}}>{authAlert}</Alert>
                :null
              }
                {/* <Typography color="textSecondary" variant="body1">
                  Нет аккаунта?{' '}
                  <Link component={RouterLink} to="/sign-up" variant="h6">
                    Зарегистрироваться
                  </Link>
                </Typography> */}
        </form>
          
          </div>       
        </Grid>  
       
        <Grid className={classes.rightContainer} item lg={6}>
          <div className={classes.tr}></div>  
          <div className={classes.logo}></div>   
        </Grid>
      </Grid>
    </div>
  );
};

export default SignIn;
